import { render, staticRenderFns } from "./GigReviewForm.vue?vue&type=template&id=2d58a347"
import script from "./GigReviewForm.vue?vue&type=script&lang=js"
export * from "./GigReviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports